import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { AuthorizedSignerDetailFragmentDoc } from '../fragments/authorizedSignerDetail.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AuthorizedSignerQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type AuthorizedSignerQuery = { __typename?: 'Query', authorizedSigner: { __typename?: 'AuthorizedSigner', id: string, name: string, event_account_id: string, event_account_name: string, can_use_all_item_locations: boolean, allowed_item_locations?: Array<{ __typename?: 'ItemLocation', id: string, name: string }> | null, event_account: { __typename?: 'EventAccount', item_locations?: Array<{ __typename?: 'ItemLocation', id: string, name: string, can_be_deleted: boolean, event_account_id?: string | null }> | null } } };


export const AuthorizedSignerDocument = gql`
    query AuthorizedSigner($id: ID!) {
  authorizedSigner(id: $id) {
    ...AuthorizedSignerDetail
  }
}
    ${AuthorizedSignerDetailFragmentDoc}`;

/**
 * __useAuthorizedSignerQuery__
 *
 * To run a query within a React component, call `useAuthorizedSignerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthorizedSignerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthorizedSignerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAuthorizedSignerQuery(baseOptions: Apollo.QueryHookOptions<AuthorizedSignerQuery, AuthorizedSignerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthorizedSignerQuery, AuthorizedSignerQueryVariables>(AuthorizedSignerDocument, options);
      }
export function useAuthorizedSignerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthorizedSignerQuery, AuthorizedSignerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthorizedSignerQuery, AuthorizedSignerQueryVariables>(AuthorizedSignerDocument, options);
        }
export type AuthorizedSignerQueryHookResult = ReturnType<typeof useAuthorizedSignerQuery>;
export type AuthorizedSignerLazyQueryHookResult = ReturnType<typeof useAuthorizedSignerLazyQuery>;
export type AuthorizedSignerQueryResult = Apollo.QueryResult<AuthorizedSignerQuery, AuthorizedSignerQueryVariables>;